import React from "react";
import { Route } from "react-router-dom";
import { AdminGuard } from "../components/AuthComponents/AdminGuard";
import { TBS_ONLY } from "../config";

import DailyBudgetPage from "../pages/DailyBudgetPage/DailyBudgetPage";
import HomePage from "../pages/HomePage/HomePage";
import ProcessOrderPage from "../pages/ProcessOrderPage/ProcessOrderPage";
import SecurityCameraInstallingPage from "../pages/SecurityCameraInstallingPage/SecurityCameraInstallingPage";
import ProductDetailPage from "../pages/ProductDetailPage/ProductDetailPage";
import MobilePhoneRepairing from "../pages/MobilePhoneRepairing/MobilePhoneRepairing";
import ComputerRepairing from "../pages/ComputerRepairingPage/ComputerRepairingPage";
import OrderPage from "../pages/OrderPage/OrderPage";
import LocationPage from "../pages/LocationPage/LocationPage";
import RedirectToGames from "../pages/GamesPage/GamesPage";
import PrivacyPolicyPage from "../pages/PrivacyPolicyPage/PrivacyPolicyPage";
import ConditionsPage from "../pages/ConditionsPage/ConditionsPage";
import ItemMaintenancePage from "../pages/ItemMaintenancePage/ItemMaintenancePage";
import CreateItemPage from "../pages/ItemMaintenancePage/CreateItemPage";
import ItemListPage from "../pages/ItemMaintenancePage/ItemListPage";
import EducationPage from "../pages/EducationPage/EducationPage";
import EducationDetailPage from "../pages/EducationPage/EducationDetailPage";
import BannerListPage from "../pages/BannerMaintenancePage/BannerListPage";
import CreateBannerPage from "../pages/BannerMaintenancePage/CreateBannerPage";
import BannerEditPage from "../pages/BannerMaintenancePage/BannerEditPage";
import EducationItemListPage from "../pages/EducationItemMaintenancePage/EducationItemListPage";
import CreateEducationItemPage from "../pages/EducationItemMaintenancePage/CreateEducationItemPage";
import EducationItemEditPage from "../pages/EducationItemMaintenancePage/EducationItemEditPage";
import AlegraItemsPage from "../pages/AlegraItemsPage/AlegraItemsPage";
import DeliveryZoneListPage from "../pages/DeliveryMaintenancePage/DeliveryZoneListPage";

// The storefront's routes — the shop, and the admin screens that maintain it.
//
// **Moved out of `app.tsx` by `TBS-78`, to be the mirror of `tbsRoutes()`.** The two files now
// answer the same question about opposite halves of one bundle: does this half exist in this build?
// A `TBS_ONLY` build is the management app, and a POS that carries a shopping cart, a catalog and a
// checkout is not one — the app's dev distribution opened on the shop's front page until this
// ticket, with `/gestion` reachable only by typing it.
//
// **`tbsRoutes()` returns a fragment and so does this**, deliberately: `<Routes>` reads its children
// directly, and keeping each route visible as JSX is what lets a reviewer scan the route table.
//
// Unlike `tbsRoutes`, these pages are **statically imported**. That is the honest state of things
// rather than an oversight: `TBS_ONLY` removes the routes, not the code, so every page below is
// still compiled into the app's bundle. Making the bundle smaller means two builds that share no
// file, which is `TBS-64`.

/** Returns the routes as a fragment, or `null` when this build is the management app alone. */
export const storefrontRoutes = () => {
  if (TBS_ONLY) return null;

  return (
    <>
      <Route path="/" element={<HomePage />} />
      <Route path="/ubicacion" element={<LocationPage />} />
      <Route path="/reparacion-de-celulares" element={<MobilePhoneRepairing />} />
      <Route path="/reparacion-de-computadores" element={<ComputerRepairing />} />
      <Route
        path="/instalacion-de-camaras-de-seguridad"
        element={<SecurityCameraInstallingPage />}
      />
      <Route path="/producto/:id" element={<ProductDetailPage />} />
      <Route path="/item-maintenance/new" element={<AdminGuard component={CreateItemPage} />} />
      <Route
        path="/item-maintenance/:id"
        element={<AdminGuard component={ItemMaintenancePage} />}
      />
      <Route path="/item-maintenance" element={<AdminGuard component={ItemListPage} />} />
      <Route path="/banner-maintenance/new" element={<AdminGuard component={CreateBannerPage} />} />
      <Route path="/banner-maintenance/:id" element={<AdminGuard component={BannerEditPage} />} />
      <Route path="/banner-maintenance" element={<AdminGuard component={BannerListPage} />} />
      <Route
        path="/education-item-maintenance/new"
        element={<AdminGuard component={CreateEducationItemPage} />}
      />
      <Route
        path="/education-item-maintenance/:slug"
        element={<AdminGuard component={EducationItemEditPage} />}
      />
      <Route
        path="/education-item-maintenance"
        element={<AdminGuard component={EducationItemListPage} />}
      />
      <Route path="/alegra-items" element={<AdminGuard component={AlegraItemsPage} />} />
      <Route
        path="/delivery-maintenance"
        element={<AdminGuard component={DeliveryZoneListPage} />}
      />
      <Route path="/hacer-pedido" element={<ProcessOrderPage />} />
      <Route path="/pedido/:id" element={<OrderPage />} />
      <Route path="/politica-de-privacidad" element={<PrivacyPolicyPage />} />
      <Route path="/condiciones-del-servicio" element={<ConditionsPage />} />
      <Route path="/educacion/:slug" element={<EducationDetailPage />} />
      <Route path="/educacion" element={<EducationPage />} />
      <Route path="/contabilidad" element={<AdminGuard component={DailyBudgetPage} />} />
      <Route path="/games" element={<RedirectToGames />} />
    </>
  );
};

export default storefrontRoutes;
